import React from 'react';
import { object, arrayOf, func } from 'prop-types';

export default function NoItems({ items, resetFilters }) {
    if (items && items.length) return null;

    return (
        <div className="listing-no-results">
            <h2>No results found</h2>
            <p>There are no items that match your query.<br /><button className="btn-skin-1" onClick={resetFilters}>Reset filters</button>.</p>
        </div>
    );
}
NoItems.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    items: arrayOf(object).isRequired,
    resetFilters: func.isRequired
    /* eslint-enable react/no-typos */
};
